import React, { memo } from 'react';
import cn from 'classnames';
import { Button as ButtonBase } from 'shared/components/Button';
import { useContextAdvancedMath } from 'components/pages/AdvancedMath/context';
import { BUTTON_DATA } from '../../../data';
import styles from './index.module.scss';
import type * as I from './types/interfaces';

export const Button = memo(function Button({ className }: I.ButtonProps) {
  const { type, paymentLink } = useContextAdvancedMath();
  const contentButton = BUTTON_DATA[type];
  const href = type === 'notBought' && paymentLink ? paymentLink : contentButton.link;

  return (
    <ButtonBase
      text={contentButton.text}
      href={href}
      className={cn(styles.root, className)}
      defaultOnClick
    />
  );
});
